import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {useNavigate} from '../../ui/navigation/use-navigate';
import {setBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {BootstrapData} from '@ui/bootstrap-data/bootstrap-data';

interface Response extends BackendResponse {
  status: 'existing_user' | 'new_user';
  bootstrapData?: BootstrapData | string;
  mobile_number?: string;
}

export interface VerifyMobileOtpPayload {
  mobile_number: string;
  code: string;
}

export function useVerifyMobileOtp() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload: VerifyMobileOtpPayload) => verifyMobileOtp(payload),
    onSuccess: response => {
      if (response.status === 'existing_user' && response.bootstrapData) {
        setBootstrapData(response.bootstrapData);
        navigate('/');
      } else {
        navigate(`/register?mobile_number=${response.mobile_number ?? ''}`);
      }
    },
  });
}

function verifyMobileOtp(payload: VerifyMobileOtpPayload): Promise<Response> {
  return apiClient
    .post('mobile-otp/verify', payload)
    .then(response => response.data);
}
